import * as React from 'react'
import {MarkdownView} from '../../common/MarkdownView'
import {IReduxState} from '../../../redux/types/IReduxState'
import {useSelector} from 'react-redux'
import {Icon, THEME_COLORS} from 'ac_ui'
import {acCheckCircleOutline} from 'ac-icon'
import {TaskDto, TaskListItemDto} from 'learndb-share'

interface IDescriptionProps {
  id: string
}

const Description: React.FC<IDescriptionProps> = () => {
  const task = useSelector<IReduxState, TaskDto>((state) => state.task?.task)
  const themeTasks = useSelector<IReduxState, TaskListItemDto[]>((state) => state.task?.themeTasks)
  const isQueryResultEquals = useSelector<IReduxState, boolean>((state) => state.task?.isQueryResultEquals)
  const name = task?.name
  const description = task?.description
  const taskId = task?.taskId

  const getTaskNumber = (): string => {
    let number
    themeTasks.forEach((themeTask, index) => {
      if (themeTask.taskId === taskId) {
        number = index + 1
      }
    })

    if (number) {
      return number + '/' + themeTasks.length
    } else {
      return ''
    }
  }

  let solvedSpan
  if (isQueryResultEquals) {
    solvedSpan = (
      <div className={'d-flex ml-x1 mb-x4'}>
        <Icon path={acCheckCircleOutline} title={'Выполнено'} color={THEME_COLORS.success} />
      </div>
    )
  }

  return (
    <div className={'custom-scroll h-100 pt-x6 pb-0 pr-x1 pl-x6 mr-x1'}>
      <div className={'task-header-container'}>
        <h2 className={'task-block-header task-name'}>Задача</h2>
        {solvedSpan}
      </div>
      <MarkdownView content={description} className={'pb-x6'} />
    </div>
  )
}

export {Description}
